import { Link } from 'gatsby';
import { AttachmentBar } from "nca-acquiring-theme";
import * as React from 'react';
export default {
  Link,
  AttachmentBar,
  React
};